import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { CheckOutStateContext } from '../../../providers/CheckOutStateContextProvider';
import { Skin } from '../../../models/common/Skin';

const useStyles = makeStyles({
  button: {
    backgroundColor: props => (props as Skin).primary_main_color + ' !important',
  },
});

const MiniButtonInternal = withStyles((themePrimary) => ({
  root: {
    color: themePrimary.palette.primary.contrastText,
    borderRadius: '20px',
    boxShadow: 'none',
    fontSize: '1em',
  },
}))(Button);

export type MiniButtonClickHandler = (event: React.MouseEvent<HTMLButtonElement>) => any;

export interface MiniButtonProps {
    value: string,
    label: string,
    disabled: boolean,
    onClickHandler: MiniButtonClickHandler
}

export default function MiniButton(props: MiniButtonProps) {
    const { value, label, disabled, onClickHandler } = props;
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

  return (
    <div>
        <MiniButtonInternal 
            className={classes.button}
            value={value}
            variant="contained" 
            disabled={disabled}
            onClick={onClickHandler}>
            {label}
        </MiniButtonInternal>
    </div>
  );
}